import { isGuid } from 'owa-favorites';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export default {
    ToggleFavoritePersona: {
        datapoint: {
            name: 'ToggleFavoritePersona',
            customData: function (personaId, emailAddress, displayName, actionSource) { return [actionSource]; },
        },
    },
    RemoveFavoritePersonaAction: {
        datapoint: {
            name: 'RemoveFavoritePersonaAction',
            customData: function (personaId, actionSource) { return [actionSource]; },
        },
    },
    AddFavoriteFolderFailure: {
        datapoint: {
            name: 'AddFavoriteFolderFailure',
        },
    },
    RemoveFavoriteFolderFailure: {
        datapoint: {
            name: 'RemoveFavoriteFolderFailure',
        },
    },
    AddFavoriteGroup: {
        datapoint: {
            name: 'AddFavoriteGroup',
            customData: function (idToUpdate, actionSource) { return [
                actionSource,
                null,
            ]; },
        },
    },
    AddFavoriteGroupFailure: {
        datapoint: {
            name: 'AddFavoriteGroupFailure',
        },
    },
    RemoveFavoriteGroup: {
        datapoint: {
            name: 'RemoveFavoriteGroup',
            customData: function (idToUpdate, actionSource) { return [
                actionSource,
                null,
            ]; },
        },
    },
    RemoveFavoriteGroupFailure: {
        datapoint: {
            name: 'RemoveFavoriteGroupFailure',
        },
    },
    AddFavoriteSearch: {
        datapoint: {
            name: 'AddFavoriteSearch',
            customData: function (searchQuery, actionSource) { return [
                actionSource,
                isControlFeatureEnabled('tri-favorites-roaming'),
            ]; },
        },
    },
    RemoveFavoriteSearch: {
        datapoint: {
            name: 'RemoveFavoriteSearch',
            customData: function (searchQuery, actionSource) { return [
                actionSource,
                isControlFeatureEnabled('tri-favorites-roaming'),
            ]; },
        },
    },
    AddFavoritePersonaAction: {
        datapoint: {
            name: 'AddFavoritePersonaAction',
            customData: function (emailAddress, displayName, personaId, actionSource) { return [actionSource]; },
        },
    },
    AddFavoritePersonaOldAction: {
        datapoint: {
            name: 'AddFavoritePersonaOldAction',
            customData: function (emailAddress, displayName, personaId, actionSource) { return [actionSource]; },
        },
    },
    LoadFavorites: {
        datapoint: {
            name: 'LoadFavorites',
            customData: function (favoriteFolders, favoritePersonas) { return [
                favoriteFolders,
                favoritePersonas,
            ]; },
        },
    },
    ValidateAndUpdateFavorite: {
        datapoint: {
            name: 'ValidateAndUpdateFavorite',
            customData: function (currentNodeId, currentPersonaEmail, currentDisplayName) { return (isGuid(currentNodeId) ? [currentNodeId] : null); },
        },
    },
    AddFavoritePersonaFailure: {
        datapoint: {
            name: 'AddFavoritePersonaFailure',
            customData: function (error) { return [error]; },
        },
    },
    AddFavoritePersonaOldFailure: {
        datapoint: {
            name: 'AddFavoritePersonaOldFailure',
            customData: function (error) { return [error]; },
        },
    },
    RemoveFavoritePersonaFailure: {
        datapoint: {
            name: 'RemoveFavoritePersonaFailure',
            customData: function (error, favoriteId, favoriteCount) { return [
                error,
                favoriteId,
                favoriteCount,
            ]; },
        },
    },
    DeleteFolderFailure: {
        datapoint: {
            name: 'DeleteFolderFailure',
            customData: function (error) { return [error]; },
        },
    },
    UpdatePersonaAndSearchFolderFailure: {
        datapoint: {
            name: 'UpdatePersonaAndSearchFolderFailure',
            customData: function (error) { return [error]; },
        },
    },
    OnFavoritePersonaSelectedAction: {
        datapoint: {
            name: 'OnFavoritePersonaSelectedAction',
        },
    },
    OnFavoritePersonaUpdatedAction: {
        datapoint: {
            name: 'OnFavoritePersonaUpdatedAction',
        },
    },
    InitializeFavoritePersonasAction: {
        datapoint: {
            name: 'InitializeFavoritePersonasAction',
        },
    },
    RetrievePersonaSearchFoldersFailed: {
        datapoint: {
            name: 'RetrievePersonaSearchFoldersFailed',
            customData: function (error) { return [error]; },
        },
    },
    UpdateUserConfigurationFailed: {
        datapoint: {
            name: 'UpdateUserConfigurationFailed',
            customData: function (error) { return [error]; },
        },
    },
    OneOffAddressUsedForFavorite: {
        datapoint: {
            name: 'OneOffAddressUsedForFavorite',
        },
    },
    /*
    TODO: turn off iscore for all outlook migration datapoints once the flight scope in production increases
    tracking workitem:
    https://msfast.visualstudio.com/FAST/_workitems/edit/253351
*/
    MigrateOutlookFavoriteService: {
        datapoint: {
            name: 'MigrateOutlookFavoriteService',
            options: {
                isCore: true,
            },
        },
    },
    MigrateOutlookFavoriteSingleBatchService: {
        datapoint: {
            name: 'MigrateOutlookFavoriteSingleBatchService',
            options: {
                isCore: true,
            },
        },
    },
    FirstAttemptMigrationCompleted: {
        datapoint: {
            name: 'FirstAttemptMigrationCompleted',
            options: {
                isCore: true,
            },
            customData: function (hasError) { return [hasError]; },
        },
    },
    SecondAttemptMigrationCompleted: {
        datapoint: {
            name: 'SecondAttemptMigrationCompleted',
            options: {
                isCore: true,
            },
            customData: function (hasError) { return [hasError]; },
        },
    },
    OutlookFavoritePersonaRootFolderLoaded: {
        datapoint: {
            name: 'OutlookFavoritePersonaRootFolderLoaded',
        },
    },
    OutlookFavoritePersonasLoaded: {
        datapoint: {
            name: 'OutlookFavoritePersonasLoaded',
        },
    },
};
//# sourceMappingURL=datapoints.js.map